
document.addEventListener('DOMContentLoaded', function () {
    var stickyBar = document.querySelector('[data-sticky-add-to-cart]');
    if (!stickyBar) return;

    // Create close button dynamically
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'sticky-close-btn';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

    stickyBar.appendChild(closeBtn);

    closeBtn.addEventListener('click', function () {
        stickyBar.style.display = 'none';
    });
});
